import { toast } from "react-toastify";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const { handlerLoading } = useGeneralAppStore.getState();

export const getInfraccionConImagenes = async (
  denuncia_id,
  setInfraccionesNuevas,
  setIsLoading
) => {
  // setIsLoading(true);
  try {
    handlerLoading({ loading: true, loadName: "detalle_denuncia" });
    const result = await axios().get(`get_denuncias_para_aprobar/${denuncia_id}`);
    const { data, error } = result.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }

    if (data) {
      setInfraccionesNuevas((prevState) => ({
        ...prevState,
        infraccion_seleccionada: {
          ...prevState.infraccion_seleccionada,
          fotos: data.imagen,
        },
      }));
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "detalle_denuncia" });
  }

  // setIsLoading(false);
};
